import BaseAnnotationLayer from "./BaseAnnotationLayer";
import {deepBioApp} from "../app_maker";
import {store} from "../../../helper/store";
import {openTopApp, updateActiveMap} from "../../../redux_actions/gamma.state.action";
import {expandAnnotation} from "../../../redux_actions/triggers.action";
import Circle from "../drawTools/Circle";
import Rectangle from "../drawTools/Rectangle";
import Polygon from "../drawTools/Polygon";

class DeepBioLayer extends BaseAnnotationLayer {
	id = deepBioApp.id;
	label = "DeepBio Layer";
	drawer = deepBioApp.drawer;
	tools = [Circle, Rectangle, Polygon];

	onFeatureSelect = (feature) => {
		store.dispatch(updateActiveMap(this.props.map.get('id')));
		store.dispatch(openTopApp(deepBioApp));
		store.dispatch(expandAnnotation(feature.getId()));
	}
}

export default DeepBioLayer;
